import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  ({ spacing, breakpoints }) => ({
    root: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: spacing(3),

      [breakpoints.up('sm')]: {
        '&.x2': {
          gridTemplateColumns: '1fr 1fr',
        },

        '&.x3, &.x4, &.x5': {
          gridTemplateColumns: '1fr 1fr 1fr',
        },
      },

      [breakpoints.up('md')]: {
        '&.x4': {
          gridTemplateColumns: '1fr 1fr 1fr 1fr',
        },

        '&.x5': {
          gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
        },
      },
    },
  }),
  { name: 'CtaGroup' },
);

export default useStyles;
